import { Pipe, type PipeTransform } from '@angular/core';
import { isString, isUndefined } from "lodash";

@Pipe({
    name: 'stripTags',
    standalone: false
})
export class StripTagsPipe implements PipeTransform {
  transform(input: string): any {
    if (!isString(input) || isUndefined(input)) return input;

    return input.replace(/<\S[^><]*>/g, '');
  }
}